let globalHeaders: Record<string, string> = {};

export const setGlobalHeadersSpaceApi = (headers: Record<string, string>) => {
	globalHeaders = { ...globalHeaders, ...headers };
};

export const removeGlobalHeadersSpaceApi = (headerKeys: string[]) => {
	headerKeys.forEach((key) => {
		delete globalHeaders[key];
	});
};

export const getGlobalHeadersSpaceApi = () => globalHeaders;
